module.exports = __webpack_public_path__ + "img/b1b1b1.809d9584.png";